import { get, post } from '@/plugins/http'

export default {
  // getCourseList: post('/live/api/v1/course/mobile/list'),
  // getCourseDetail: get('/live/api/v1/course/mobile/detail'),
  // getHomeRecommend: get('/live/api/v1/course/mobile/recommend/home'),
  // getHomeList: get('/live/api/v1/course/mobile/list/home'),
  getCourseList: post('/live/api/v1/course/mobile/auth/list'),
  getSystemCourseList: get('/live/api/v1/course/list/{systemMark}'),
  getCourseDetail: get('/live/api/v1/course/mobile/auth/detail'),
  getCourseData: get('/live/api/v1/course/data/detail'),
  getHomeRecommend: get('/live/api/v1/course/mobile/recommend/auth/home'),
  getHomeList: get('/live/api/v1/course/mobile/list/auth/home'),
  getHomeLiveRecent: get('/live/api/v1/course/mobile/auth/pageIndex'),
  getHomeRecordRecent: get('/live/api/v1/recordCourse/auth/mobile'),
  getRecord: get('/live/api/v1/recordCourse/auth/mobile/{courseId}'),
  getRecordData: get('/live/api/v1/recordCourse/data/{courseId}'),
  getRecordRecommend: get('/live/api/v1/recordCourse/mobile/recommend/{type}'),
  getRecordCourseCategory: get('/live/api/v1/recordCourse/category/list?liveShow=false'),
  getRecordCourseByType: get('/live/api/v1/recordCourse/auth/mobile/list'),
  // 添加视频播放记录
  addVideoRecord: post('/live/api/v1/record'),
  getVideoRecord: get('/live/api/v1/record/{courseId}/{videoId}'),
  getVideo: get('/live/api/v1/video/data/mobile/{videoId}'),
  getVideoFromNim: get('/live/api/v1/course/video/{vid}'),
  getVideos: get('/live/api/v1/video/data/mobile/list'),
  setCourseSingup: post('/live/api/v1/course/signUp'),
  downloadCourseFile: get('/api/v1/outer/file/seaFile/download/{courseId}'),
  getMyCourses: post('/live/api/v1/course/list/signUp/history'),
  setCourseCommend: post('/live/api/v1/comment/add'),
  getQuote: get('/live/api/v1/quote/random'),
  // 获取法税过滤数据
  getFiscalFilter: get('/fiscal-tax/api/v1/courseWhite/searchVisibleCourse'),
  // 获取法税过滤数据
  saveFiscalPhone: get('/fiscal-tax/api/v1/course/savePhone'),
  // 获取禁言用户列表
  getMuteUserList: get('/live/api/v1/course/{roomid}/muteUserList'),
  // 设置禁言
  setMuteUser: post('/live/api/v1/im/chatroom/setUserMute'),
  // 点播答题相关
  getQuestionBank: get('/live/api/v1/course/answer/mobile/questionBank'),
  submitAnswer: post('/live/api/v1/course/answer/mobile/submitAnswers'),
  getScore: get('/live/api/v1/course/answer/mobile/getScore'),
  getCoursePv: get('/live/api/v1/course/mobile/pv/{courseId}'),
  // 观看时长统计
  findCourseStatisticVo: get('/live/api/v1/statistic/course/findCourseStatisticVo/{id}'),
}
